<template>
    <div :class="['mx-auto max-w-2xl', align === 'center' ? 'text-center' : 'text-left', align === 'center' ? '' : 'lg:mx-0']">
        <span v-if="eyebrow"
            class="inline-flex items-center rounded-full bg-primary-50 px-3 py-1 text-sm font-semibold text-primary-700 ring-1 ring-inset ring-primary-600/10">
            {{ eyebrow }}
        </span>
        <p class="mt-4 text-pretty text-3xl font-semibold tracking-tight text-gray-900 sm:text-4xl">
            <slot name="title">{{ title }}</slot>
        </p>
        <p v-if="description || $slots.description" class="mt-4 text-lg/8 text-gray-600">
            <slot name="description">{{ description }}</slot>
        </p>
    </div>
</template>

<script setup>
defineProps({
    eyebrow: { type: String, default: '' },
    title: { type: String, default: '' },
    description: { type: String, default: '' },
    align: { type: String, default: 'center' },
});
</script>
